import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import Loader from "react-loader-spinner";

const LoadingIndicator = props =>{

    const{promiseInProgress} = usePromiseTracker();
    return(
        promiseInProgress &&
            <div>
                <div
                    style ={{
                        width: "100%",
                        height: "100",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}>
                    <Loader type={"Oval"} color = "#4e95f4" height={"100"} width={"100"}/>
                </div>
            </div>
    );
}

export default LoadingIndicator;
